import { FILE_BROWSER_URL } from '@/Module/Core/Constant';

export const LAYOUT_API = {
  GET_CAMPAIGN: `${FILE_BROWSER_URL}/campaign/campaign.json`,
};
